import { render } from "./Check.vue?vue&type=template&id=4025f5c7&scoped=true"
import script from "./Check.vue?vue&type=script&lang=js"
export * from "./Check.vue?vue&type=script&lang=js"

import "./Check.vue?vue&type=style&index=0&id=4025f5c7&lang=scss&scoped=true"
import "./Check.vue?vue&type=style&index=1&id=4025f5c7&lang=scss"

import exportComponent from "/codebuild/output/src1847379700/src/basejumper-amplify/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4025f5c7"]])

export default __exports__